
// @ts-nocheck


export const localeCodes =  [
  "de",
  "fr"
]

export const localeLoaders = {
  de: [
    {
      key: "locale_cms_46ts_f25a17f5",
      load: () => import("#nuxt-i18n/f25a17f5" /* webpackChunkName: "locale_cms_46ts_f25a17f5" */),
      cache: false
    }
  ],
  fr: [
    {
      key: "locale_cms_46ts_f25a17f5",
      load: () => import("#nuxt-i18n/f25a17f5" /* webpackChunkName: "locale_cms_46ts_f25a17f5" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/cfcb45fa" /* webpackChunkName: "config_i18n_46config_46ts_cfcb45fa" */)
]

export const nuxtI18nOptions = {
  restructureDir: "./",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "de",
      files: [
        "/vercel/path0/lang/cms.ts"
      ]
    },
    {
      code: "fr",
      files: [
        "/vercel/path0/lang/cms.ts"
      ]
    }
  ],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "lang/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "de",
    files: [
      {
        path: "/vercel/path0/lang/cms.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    files: [
      {
        path: "/vercel/path0/lang/cms.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/